module.exports = __webpack_public_path__ + "media/605CommonSpace.c1f904a4.mp4";